import { GuidService } from 'ui-components/services/guid-service';
import type { WorkflowFilter as ApiWorkflowFilter, WorkflowAction as ApiWorkflowAction } from '../../../api/automation-workflow-types';
import type { WorkflowFilterDraft, WorkflowActionDraft } from '../../types.d';
import { filterTypeHandlers } from './filter-type-handlers';
import { actionTypeHandlers } from './action-type-handlers';

// Expands a single WorkflowFilter payload into individual flat draft rows.
// Dispatches to the correct handler based on the filter's type discriminant.
// New filter types only require adding a handler to filter-type-handlers.ts.
export const convertFromApiFilter = (apiFilter: ApiWorkflowFilter): WorkflowFilterDraft[] => {
  const handler = filterTypeHandlers[apiFilter.type];
  if (!handler) {
    return [];
  }
  return handler.fromApi(apiFilter.definition);
};

export const convertFromApiAction = (apiAction: ApiWorkflowAction): WorkflowActionDraft => {
  const handler = actionTypeHandlers[apiAction.type];
  if (!handler) {
    return {
      id: GuidService.newGuid(),
      actionTypeId: 0,
      parameter: null,
      intParameter: null,
    };
  }
  return handler.fromApi(apiAction.definition);
};
